import React, { useState } from 'react'

import { Icon, ChevronUp, ChevronDown } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, node, string } from 'prop-types'

function CollapsibleSection({ title, children, defaultOpen = true }) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className="more-filters__section">
      <button
        type="button"
        className="more-filters__section-header cgt-overline-md"
        onClick={() => setIsOpen(o => !o)}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <Icon
          notSpaced
          svgComponent={isOpen ? ChevronUp : ChevronDown}
          color="darker"
          size="small"
        />
      </button>
      {isOpen && <div className="more-filters__section-content">{children}</div>}
    </div>
  )
}

CollapsibleSection.propTypes = {
  title: string.isRequired,
  children: node.isRequired,
  defaultOpen: bool,
}

export default CollapsibleSection
